import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import s from './ProfilePage.scss';
import { connect } from 'react-redux';
import actions from './profilePageActions';
import DetailsCard from './DetailsCard';
import ExpertData from './ExpertData';
import NoProfile from './NoProfile';
import { goToDirectBrief } from '../../utils/goToBrief';
import expertLocation from '../../utils/expertLocationFormatter';
import isServer from '../../utils/isServer';
import * as seo from '../../utils/seo';

const mapStateToProps = ({ profile, initialData }) => ({
  expertLoaded: profile.expertLoaded,
  expert: profile.expert,
  expertNotFound: profile.expertNotFound,
  arenaUserInfo: initialData.arenaUserInfo,
  staticsBaseUrl: initialData.staticsBaseUrl,
  possibleLanguages: initialData.possibleLanguages,
  url: isServer ? initialData.url : window.location.href,
});
class ProfilePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMyProfile:
        this.props.match.params.userName === props.arenaUserInfo.userName,
    };
  }

  static fetchData(store, match, staticContext) {
    return store.dispatch(
      actions.loadExpertData(match.params.userName, staticContext),
    );
  }

  componentDidMount() {
    if (
      !(
        this.props.expertLoaded &&
        this.props.expert.userName === this.props.match.params.userName
      )
    ) {
      this.props.loadExpertData(this.props.match.params.userName);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.userName !== prevProps.match.params.userName) {
      this.props.unloadExpertData();
      this.props.loadExpertData(this.props.match.params.userName);
      this.setState({
        isMyProfile:
          this.props.match.params.userName ===
          this.props.arenaUserInfo.userName,
      });
    }
  }

  componentWillUnmount() {
    this.props.unloadExpertData();
  }

  handleGetQuoteClicked = (entry, categoryId, serviceId) => {
    goToDirectBrief({
      guid: this.props.expert.id,
      name: this.props.expert.personalDetails.name,
      entry,
      categoryId,
      serviceId,
    });
  };

  render() {
    const {
      t,
      history,
      expertLoaded,
      expert,
      expertNotFound,
      staticsBaseUrl,
      url,
      possibleLanguages,
    } = this.props;
    const { isMyProfile } = this.state;

    return (
      <div className={s.profilePageContainer}>
        {expertLoaded &&
          seo.generateHelmet({
            possibleLanguages,
            title: t('arena_profile_page_seo_title', {
              name: expert.personalDetails.name,
            }),
            description: t('arena_profile_page_seo_description', {
              name: expert.personalDetails.name,
              languages: expert.languages.values
                .map(lang => t(`language_${lang}`))
                .join(', '),
              location: expertLocation(expert.personalDetails),
              reviewsScore: expert.reviewScores ? expert.reviewScores.score : 0,
              numOfReviews: expert.reviewScores ? expert.reviewScores.count : 0,
              numOfProjects: expert.scores
                ? parseInt(expert.scores.projects, 10)
                : 0,
            }),
            url,
            socialsImage: expert.personalDetails.profilePhoto,
          })}
        {expertLoaded && (
          <main className={s.mainContainer} data-hook="profile-screen">
            <section
              className={s.detailsCardContainer}
              data-hook="expert-details-card"
            >
              <DetailsCard
                expert={expert}
                possibleLanguages={possibleLanguages}
                onContactMeClicked={() => {
                  this.handleGetQuoteClicked('generalMenu', 1, 1);
                }}
                isMyProfile={isMyProfile}
                history={history}
              />
            </section>
            <section className={s.expertDataContainer} data-hook="expert-data">
              <ExpertData
                expert={expert}
                onGetQuoteClick={this.handleGetQuoteClicked}
                isMyProfile={isMyProfile}
                staticsBaseUrl={staticsBaseUrl}
              />
            </section>
          </main>
        )}
        {expertNotFound && <NoProfile t={t} staticsBaseUrl={staticsBaseUrl} />}
      </div>
    );
  }
}

ProfilePage.propTypes = {
  t: PropTypes.func,
  expertLoaded: PropTypes.bool,
  expert: PropTypes.object,
  expertNotFound: PropTypes.bool,
  loadExpertData: PropTypes.func,
  unloadExpertData: PropTypes.func,
  match: PropTypes.any,
};

const ConnectedProfilePage = connect(mapStateToProps, { ...actions })(
  ProfilePage,
);

export default translate()(ConnectedProfilePage);
